import Link from "next/link";
import { useTranslation } from "react-i18next";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import useWindowSize from "src/hooks/useWindowSize";

const VoucherSlider = (props) => {
  const { t } = useTranslation("common");
  const { width } = useWindowSize();
  const isMobile = width < 900;
  // New data for the slider
  const newData = [
    {
      id: 1,
      title: t("voucher.voucher_slider_title_1"),
      imageURL:
        process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
        "cdn/statics/Voucher/Gutschein_2490x1816/Dein-aktiver-Traumurlaub_moverii-Gutschein.jpg",
    },
    {
      id: 2,
      title: t("voucher.voucher_slider_title_2"),
      imageURL:
        process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
        "cdn/statics/Voucher/Gutschein_2490x1816/Auf-in-die-Natur_moverii-Gutschein.jpg",
    },
    {
      id: 3,
      title: t("voucher.voucher_slider_title_3"),
      imageURL:
        process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
        "cdn/statics/Voucher/Gutschein_2490x1816/Ticket-in-die-Freiheit_moverii-Gutschein.jpg",
    },
    {
      id: 4,
      title: t("voucher.voucher_slider_title_4"),
      imageURL:
        process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
        "cdn/statics/Voucher/Gutschein_2490x1816/Dein-Urlaub-zum-Worhlfühlen_gutschein-moverii.jpg",
    },
    {
      id: 5,
      title: t("voucher.voucher_slider_title_5"),
      imageURL:
        process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
        "cdn/statics/Voucher/Gutschein_2490x1816/Dein-Abenteuer-wartet_moverii-Gutschein.jpg",
    },
    {
      id: 6,
      title: t("voucher.voucher_slider_title_6"),
      imageURL:
        process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
        "cdn/statics/Voucher/Gutschein_2490x1816/Herzlichen-Glückwunsch_moverii-Gutschein.jpg",
    },
    {
      id: 7,
      title: t("voucher.voucher_slider_title_7"),
      imageURL:
        process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
        "cdn/statics/Voucher/Gutschein_2490x1816/Starkes-Geschenk_moverii-Gutschein.jpg",
    },
    {
      id: 8,
      title: t("voucher.voucher_slider_title_8"),
      imageURL:
        process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
        "cdn/statics/Voucher/Gutschein_2490x1816/Deine-Reise-in-den-Ring_moverii-Gutschein.jpg",
    },
    {
      id: 9,
      title: t("voucher.voucher_slider_title_9"),
      imageURL:
        process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
        "cdn/statics/Voucher/Gutschein_2490x1816/Danke-fuer-Alles_moverii-Gutschein.jpg",
    },
    {
      id: 10,
      title: t("voucher.voucher_slider_title_10"),
      imageURL:
        process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
        "cdn/statics/Voucher/Gutschein_2490x1816/Alles-Liebe_moverii-Gutschein.jpg",
    },
    {
      id: 11,
      title: t("voucher.voucher_slider_title_11"),
      imageURL:
        process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
        "cdn/statics/Voucher/Gutschein_2490x1816/Frohe-Weihnachten_moverii-Gutschein.jpg",
    },
  ];

  return (
    <div id={"dashta3"} className="md:-mx-2 md:-ml-4">
      <Swiper
        navigation={isMobile ? false : true}
        modules={[Navigation]}
        slidesPerView={5}
        spaceBetween={0}
        loop={true}
        breakpoints={{
          300: {
            slidesPerView: 1.3,
            spaceBetween: 0,
          },
          500: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 0,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 0,
          },
        }}
        className="voucher-arrow"
      >
        {newData.map((v, i) => {
          return (
            <SwiperSlide key={i}>
              <Link href={`/voucher/buy?id=${v.id}`} passHref>
                <a>
                  <div className={"px-4 py-2 pb-[50px]"}>
                    <div
                      className={
                        "bg-white shadow-lg h-full  w-full rounded-2xl border border-b-gray-300"
                      }
                    >
                      <div
                        className={
                          "flex justify-center items-center rounded-2xl m-4 mt-4"
                        }
                      >
                        <img
                          className={
                            "rounded-2xl w-full h-[250px] lg:h-[220px] object-cover object-center"
                          }
                          src={v.imageURL}
                          alt={v.title}
                        />
                      </div>
                      <div
                        className={
                          "flex h-[60px] justify-start items-start -mt-1 px-6 pb-2"
                        }
                      >
                        <h4
                          className={
                            "font-bold text-grayDark2 text-lg leading-tight"
                          }
                        >
                          {v.title}
                        </h4>
                      </div>
                    </div>
                  </div>
                </a>
              </Link>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default VoucherSlider;
